import WizardStepPage from './WizardStepPage';

/** Step 8 — FAQs */
const FaqsStep = (props) => (
    <WizardStepPage
        stepKey="faqs"
        formData={props.formData?.faqs}
        onChange={props.onChange}
        errors={props.errors}
        setErrors={props.setErrors}
        tripCurrency={props.tripCurrency}
    />
);

export default FaqsStep;
